// src/components/LandingPage.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GlassButton } from './GlassButton';
import Seo from './Seo';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="landing-container">
      <Seo
        path="/"
        title="Tudu — Smart Task Planner, Routines & Shopping Deals"
        description="Plan your day with AI: organize tasks and routines, share to-dos with your team, plan trips, and save with local deals & coupons. Free to start."
      />
      {/* Floating Decorative Elements */}
      <div className="floating-element el-1">
        <div className="glass-icon-box">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </div>
      </div>
      <div className="floating-element el-2">
        <div className="glass-icon-box">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>
      </div>
      <div className="floating-element el-3">
        <div className="glass-icon-box">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
        </div>
      </div>
      <div className="floating-element el-4">
        <div className="glass-icon-box">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
      </div>

      <div className="landing-content">
        <img src="/images/tudu_minecraft_logo.png" alt="Tudu Logo" className="landing-logo" />
        <h1 className="landing-title">Your Smart Day Planner</h1>
        <p className="landing-subtext">
          Plan smarter, shop faster, and get intelligent suggestions.
        </p>
        <div className="landing-buttons" style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <GlassButton onClick={() => navigate('/login')}>Login</GlassButton>
          <GlassButton onClick={() => navigate('/signup')}>Sign Up</GlassButton>
        </div>
      </div>
      {/* Footer Section */}
      <div className="landing-footer">
        <p>&copy; {new Date().getFullYear()} Tudu. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/terms">Terms & Conditions</Link>
          <span className="separator">|</span>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
